import icon from "../../assets/poe.svg";
import type { Property } from "../../types";

export const powerMethodPoe: Property = {
  id: "powerMethodPoe",
  title: "powerMethodPoe.title",
  icon,
};
